export default __webpack_public_path__ + "static/media/behindUsers.8d59980d.svg";